import { SecretListItem } from '@/types/secret';


export const MAX_ENV_VAR_LENGTH = 128;
export const CHAR_COUNTDOWN_THRESHOLD = 10;


export function generateEnvVarName( secretName: string, existingEnvVars: string[] ): string {
  const base = secretName
    .toUpperCase()
    .replace( /[.-]/g, '_' )
    .replace( /[^A-Z0-9_]/g, '' )
    .slice( 0, MAX_ENV_VAR_LENGTH );

  if ( !existingEnvVars.includes( base ) ) return base;

  for ( let i = 1; i < 1000; i++ ) {
    const candidate = `${ base.slice( 0, MAX_ENV_VAR_LENGTH - String( i ).length ) }${ i }`;
    if ( !existingEnvVars.includes( candidate ) ) return candidate;
  }

  throw new Error( `Unable to generate a unique env var name for "${ secretName }"` );
}

export function getExistingEnvVars( secrets: SecretListItem[] ): string[] {
  return secrets.flatMap( s => [
    ...( s.globalEnvVarName ? [ s.globalEnvVarName ] : [] ),
    ...( s.agentMappings?.map( m => m.envVarName ) ?? [] )
  ] );
}

export function charCounterText( current: number, max: number ): string | null {
  const remaining = max - current;
  if ( remaining <= CHAR_COUNTDOWN_THRESHOLD ) {
    return `${ remaining } character${ remaining !== 1 ? 's' : '' } remaining`;
  }
  return null;
}
